import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, projectAdminOk = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        <div className="flex items-center gap-3">
          <span className="status-dot bg-primary" />
          <span className="overline">Memuat CINNABIT…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (adminOnly && user.role !== "admin") {
    if (projectAdminOk && user.role === "project_admin") {
      return children;
    }
    return <Navigate to="/" replace />;
  }
  return children;
}
